const checkCart = async () => {
  const SHOP_DOMAIN = window.location.hostname;

  let pfandAccessDiv = document.querySelector("#deposit-identifier");

  if(!pfandAccessDiv) return;

  const PFAND_VARIANT_ID = parseInt(pfandAccessDiv.getAttribute("data-variant-id"));
  const STOREFRONT_ACCESS_TOKEN = pfandAccessDiv.getAttribute("data-access-token") ||  "9c77b048b0d93144dc72dd54f9a50f0b"; // Replace


  if(!PFAND_VARIANT_ID) return;

  try {
    const cart = await fetch("/cart.js").then((res) => res.json());

    let totalPfand = 0;

    for (const item of cart.items) {
      if (item.variant_id === PFAND_VARIANT_ID) continue; // skip the pfand product itself

      const variantGID = `gid://shopify/ProductVariant/${item.variant_id}`;
      const query = `
          query {
            node(id: "${variantGID}") {
              ... on ProductVariant {
                metafield(namespace: "custom", key: "pfand_anzahl") {
                  value
                }
              }
            }
          }
        `;

      const metafieldRes = await fetch(
        `https://${SHOP_DOMAIN}/api/2024-04/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
          },
          body: JSON.stringify({ query }),
        }
      );

      const metafieldData = await metafieldRes.json();
      const value = metafieldData?.data?.node?.metafield?.value;

      //console.log(value);

      if (value) {
        totalPfand += parseInt(value) * item.quantity;
      }
    }

    const pfandItem = cart.items.find(
      (item) => item.variant_id === PFAND_VARIANT_ID
    );

    if (totalPfand === 0 && pfandItem) {
      // Remove the pfand item if it's no longer needed
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: pfandItem.key, quantity: 0 }),
      });
      //console.log("Pfandprodukt entfernt.");
      cartDrawer.updateCart()
      return;
    }

    if (pfandItem) {
      // Update quantity
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: pfandItem.key,
          quantity: totalPfand,
        }),
      });
      cartDrawer.updateCart()
      //console.log("Pfandprodukt aktualisiert.");
    } else if (totalPfand > 0) {
      // Add Pfand item
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [
            {
              quantity: totalPfand,
              id: PFAND_VARIANT_ID,
            },
          ],
        }),
      });
      cartDrawer.updateCart()
      //console.log("Pfandprodukt hinzugefügt.");
    }
  } catch (error) {
    console.error("Fehler beim Verarbeiten des Pfands:", error);
  }
};

checkCart();

window.addEventListener("cart-items-added", () => {
    //console.log("Cart was edited, recalc Pfand")
    checkCart();
})
